import { Reveal } from "./Reveal";

const Leadership = () => (
  <section id="leadership" data-testid="leadership-section" aria-labelledby="leadership-heading" className="parchment-noise relative overflow-hidden border-t border-parchborder py-28 sm:py-36">
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-[auto_1.1fr_1fr] lg:gap-20">
        <Reveal>
          <ul className="hidden flex-col gap-5 border-r border-ember/30 pr-10 pt-2 lg:flex" aria-hidden="true">
            {["Strategy", "People", "Possibilities", "Legacy"].map((w) => (
              <li key={w} className="text-right font-mono text-xs uppercase tracking-[0.35em] text-royal/70">{w}</li>
            ))}
          </ul>
        </Reveal>

        <div>
          <Reveal>
            <p className="mb-5 flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.35em] text-ember sm:text-xs" data-testid="leadership-sheet-label">
              <span className="inline-block h-px w-10 bg-ember/70" />
              Sheet VHE-05 — Office of the Architect
            </p>
            <h2 id="leadership-heading" className="font-serif text-4xl font-bold tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Leadership
            </h2>
            <span className="my-8 inline-block h-px w-16 bg-gold" aria-hidden="true" />
          </Reveal>
          <Reveal delay={0.15}>
            <div className="border-l-2 border-gold pl-7">
              <h3 className="font-serif text-2xl font-semibold text-royal sm:text-3xl" data-testid="leadership-name">
                La&rsquo;Tysha Bolden-Johnson, MA
              </h3>
              <div className="mt-3" data-testid="leadership-title">
                <p className="font-mono text-sm font-semibold uppercase leading-relaxed tracking-[0.18em] text-ink sm:text-base">
                  Chief Enterprise Architect (CEA)
                </p>
                <p className="mt-1.5 font-mono text-[11px] uppercase leading-relaxed tracking-[0.18em] text-ink2 sm:text-xs">
                  LMHP Resident in Counseling (VA)
                </p>
              </div>
              <p className="mt-6 max-w-md text-base leading-relaxed text-ink2 sm:text-lg" data-testid="leadership-bio">
                A visionary strategist and behavioral-health leader combining executive architectural foresight with deep clinical insight to construct legacy-defining organizations.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <figure
            data-testid="innovation-quote"
            className="relative p-10 sm:p-14 lg:aspect-square lg:flex lg:flex-col lg:justify-center"
          >
            <span className="absolute inset-3 bg-royal/50 blur-3xl" aria-hidden="true" />
            <span className="absolute inset-0 bg-navy" aria-hidden="true" />
            <span className="absolute left-4 top-10 h-1/4 w-2/5 bg-royal/25" aria-hidden="true" />
            <span className="absolute bottom-12 right-6 h-1/3 w-1/3 bg-royal/20" aria-hidden="true" />
            <span className="absolute right-10 top-6 h-1/5 w-1/4 bg-blue-800/40" aria-hidden="true" />
            <span className="absolute inset-0 border border-royal/70" aria-hidden="true" />
            <span className="absolute inset-4 border border-gold/30" aria-hidden="true" />
            <span className="absolute -inset-3 border border-royal/40" aria-hidden="true" />
            <span className="absolute -left-4 bottom-8 right-10 top-8 border border-royal/35" aria-hidden="true" />
            <span className="absolute -right-4 bottom-14 left-8 top-4 border border-gold/25" aria-hidden="true" />
            <span className="absolute -left-10 -right-10 top-1/3 h-px bg-royal/50" aria-hidden="true" />
            <span className="absolute -left-6 -right-6 bottom-1/4 h-px bg-royal/40" aria-hidden="true" />
            <span className="absolute -bottom-8 -top-8 left-1/4 w-px bg-royal/45" aria-hidden="true" />
            <span className="absolute -bottom-6 -top-10 right-1/3 w-px bg-gold/30" aria-hidden="true" />
            <span className="absolute -left-1.5 top-1/3 h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
            <span className="absolute -right-1.5 bottom-1/4 h-1.5 w-1.5 rotate-45 bg-royal" aria-hidden="true" />
            <span className="crosshair -left-5 -top-5" aria-hidden="true" />
            <span className="crosshair -bottom-5 -right-5" aria-hidden="true" />
            <div className="relative text-center">
              <span className="absolute -top-9 -left-1 font-serif text-8xl leading-none text-gold" aria-hidden="true">&ldquo;</span>
              <span className="absolute -bottom-12 -right-1 font-serif text-8xl leading-none text-gold" aria-hidden="true">&rdquo;</span>
              <blockquote className="px-2 pt-7 font-serif text-2xl font-semibold italic leading-relaxed text-parchment sm:text-3xl">
                Innovation must be envisioned, structured, implemented and cultivated.
              </blockquote>
              <figcaption className="mt-8 pr-14 text-right font-cormorant text-2xl font-semibold italic text-ember sm:text-3xl">
                — LNBJ —
              </figcaption>
            </div>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Leadership;
